const calculateCallDuration = (duration: number): string => {
  if (duration < 0) return 'Unknown';
  return new Date(1000 * duration).toISOString().slice(11, 19);
};

export default calculateCallDuration;
